import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filter.svg'


const _hoisted_1 = { class: "dashboard-page" }
const _hoisted_2 = {
  ref: "stickyHeader",
  class: "dashboard-sticky-header"
}
const _hoisted_3 = { class: "dashboard-toolbar" }
const _hoisted_4 = { class: "section-nav" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = {
  key: 0,
  class: "filter-count"
}
const _hoisted_7 = { class: "global-filters" }
const _hoisted_8 = { class: "filter-field" }
const _hoisted_9 = { class: "filter-field" }
const _hoisted_10 = { class: "filter-field" }
const _hoisted_11 = { class: "filter-field filter-field-actions" }
const _hoisted_12 = { class: "kpi-grid" }
const _hoisted_13 = { class: "kpi-label" }
const _hoisted_14 = { class: "kpi-value" }
const _hoisted_15 = { class: "dashboard-body" }
const _hoisted_16 = { class: "filter-field" }
const _hoisted_17 = { class: "filter-field" }
const _hoisted_18 = { class: "filter-field" }
const _hoisted_19 = { class: "filter-field" }
const _hoisted_20 = { class: "filter-field" }
const _hoisted_21 = { class: "filter-field" }
const _hoisted_22 = { class: "filter-field" }
const _hoisted_23 = {
  key: 0,
  class: "filter-field"
}
const _hoisted_24 = {
  key: 1,
  class: "filter-field"
}
const _hoisted_25 = {
  key: 2,
  class: "filter-field"
}
const _hoisted_26 = { class: "filter-field" }
const _hoisted_27 = { class: "filter-field" }
const _hoisted_28 = { class: "filter-field" }
const _hoisted_29 = { class: "filter-field" }
const _hoisted_30 = { class: "filter-field" }
const _hoisted_31 = { class: "filter-field" }
const _hoisted_32 = { class: "filter-field" }
const _hoisted_33 = { class: "filter-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_DashboardFilterChips = _resolveComponent("DashboardFilterChips")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ComplianceReviewSection = _resolveComponent("ComplianceReviewSection")!
  const _component_DashboardSection = _resolveComponent("DashboardSection")!
  const _component_KpisSection = _resolveComponent("KpisSection")!
  const _component_ControlsSection = _resolveComponent("ControlsSection")!
  const _component_FindingsSection = _resolveComponent("FindingsSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionLinks, (section) => {
            return (_openBlock(), _createElementBlock("a", {
              key: section.id,
              href: '#' + section.id,
              class: _normalizeClass({ 'is-active': _ctx.activeSection === section.id }),
              onClick: _withModifiers(($event: any) => (_ctx.scrollToSection(section.id)), ["prevent"])
            }, _toDisplayString(section.label), 11, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn-filters", { 'is-open': _ctx.showGlobalFilters }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleGlobalFilters && _ctx.toggleGlobalFilters(...args)))
        }, [
          _cache[25] || (_cache[25] = _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            class: "filter-icon"
          }, null, -1)),
          _cache[26] || (_cache[26] = _createTextVNode(" Filters ")),
          (_ctx.globalFilterCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.globalFilterCount), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[27] || (_cache[27] = _createElementVNode("label", {
            class: "filter-label",
            for: "dashboard-global-time-period"
          }, "Time Period", -1)),
          _createVNode(_component_Select, {
            id: "dashboard-global-time-period",
            modelValue: _ctx.globalFilters.timePeriod,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.globalFilters.timePeriod) = $event)),
            options: _ctx.yearSeries,
            optionLabel: "value",
            optionValue: "id",
            placeholder: "Time Period",
            class: "dashboard-select",
            showClear: ""
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "filter-label",
            for: "dashboard-global-locations"
          }, "Locations", -1)),
          _createVNode(_component_MultiSelect, {
            inputId: "dashboard-global-locations",
            modelValue: _ctx.globalFilters.locations,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.globalFilters.locations) = $event)),
            options: _ctx.locations,
            optionLabel: "label",
            dataKey: "value",
            filter: true,
            maxSelectedLabels: 1,
            selectedItemsLabel: "{0} selected",
            placeholder: "All Locations",
            class: "dashboard-filter custom-multiselect userSelect"
          }, {
            empty: _withCtx(() => _cache[28] || (_cache[28] = [
              _createElementVNode("span", { class: "text-xs" }, "No Locations Found", -1)
            ])),
            _: 1
          }, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "filter-label",
            for: "dashboard-global-teams"
          }, "Teams", -1)),
          _createVNode(_component_MultiSelect, {
            inputId: "dashboard-global-teams",
            modelValue: _ctx.globalFilters.departments,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.globalFilters.departments) = $event)),
            options: _ctx.departmentsList,
            optionLabel: "label",
            dataKey: "value",
            filter: true,
            maxSelectedLabels: 1,
            selectedItemsLabel: "{0} selected",
            placeholder: "All Teams",
            class: "dashboard-filter custom-multiselect userSelect"
          }, {
            empty: _withCtx(() => _cache[30] || (_cache[30] = [
              _createElementVNode("span", { class: "text-xs" }, "No Teams Found", -1)
            ])),
            _: 1
          }, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-apply",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyGlobalFilters && _ctx.applyGlobalFilters(...args)))
          }, "Apply"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-reset",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetGlobalFilters && _ctx.resetGlobalFilters(...args)))
          }, "Reset"),
          _createElementVNode("button", {
            type: "button",
            class: "btn-reset",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelGlobalFilters && _ctx.cancelGlobalFilters(...args)))
          }, "Cancel")
        ])
      ], 512), [
        [_vShow, _ctx.showGlobalFilters]
      ]),
      _createVNode(_component_DashboardFilterChips, {
        chips: _ctx.globalChips,
        onRemove: _ctx.removeGlobalFilter
      }, null, 8, ["chips", "onRemove"]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiCards, (kpi) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: kpi.key,
            class: _normalizeClass(["kpi-card text-left", 'kpi-card--' + kpi.tone]),
            to: _ctx.kpiRoute(kpi.key),
            onClick: ($event: any) => (_ctx.markKpiRoute(kpi.key))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, _toDisplayString(kpi.label), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(kpi.display), 1)
            ]),
            _: 2
          }, 1032, ["class", "to", "onClick"]))
        }), 128))
      ])
    ], 512),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_DashboardSection, {
        "section-id": "compliance-review",
        title: "Control Review",
        loading: _ctx.crLoading,
        chips: _ctx.crChips,
        "filter-count": _ctx.crFilterCount,
        onOpen: _ctx.openCrFilters,
        onApply: _ctx.applyCrFilters,
        onReset: _ctx.resetCrFilters,
        onCancel: _ctx.cancelCrFilters,
        onRemove: _ctx.removeCrFilter
      }, {
        filters: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _cache[32] || (_cache[32] = _createElementVNode("label", {
              class: "filter-label",
              for: "cr-filter-status"
            }, "Status", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "cr-filter-status",
              modelValue: _ctx.crFilters.taskStatus,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.crFilters.taskStatus) = $event)),
              options: _ctx.statusCodes,
              optionLabel: "value",
              dataKey: "id",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "All Statuses",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[33] || (_cache[33] = _createElementVNode("label", {
              class: "filter-label",
              for: "cr-filter-task-type"
            }, "Task Type", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "cr-filter-task-type",
              modelValue: _ctx.crFilters.taskType,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.crFilters.taskType) = $event)),
              options: _ctx.taskType,
              optionLabel: "value",
              dataKey: "id",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "Task Type",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[34] || (_cache[34] = _createElementVNode("label", {
              class: "filter-label",
              for: "cr-filter-cid"
            }, "CID", -1)),
            _createVNode(_component_Select, {
              inputId: "cr-filter-cid",
              modelValue: _ctx.crFilters.control,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.crFilters.control) = $event)),
              options: _ctx.controlsList,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Select CID",
              class: "dashboard-select",
              showClear: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[35] || (_cache[35] = _createElementVNode("label", {
              class: "filter-label",
              for: "cr-filter-priority"
            }, "Priority", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "cr-filter-priority",
              modelValue: _ctx.crFilters.controlPriority,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.crFilters.controlPriority) = $event)),
              options: _ctx.dbPriority,
              optionLabel: "key",
              dataKey: "value",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "All Priorities",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[36] || (_cache[36] = _createElementVNode("label", {
              class: "filter-label",
              for: "cr-filter-frequency"
            }, "Frequency", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "cr-filter-frequency",
              modelValue: _ctx.crFilters.controlFrequency,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.crFilters.controlFrequency) = $event)),
              options: _ctx.dbFrequency,
              optionLabel: "key",
              dataKey: "value",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "All Frequencies",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[37] || (_cache[37] = _createElementVNode("label", {
              class: "filter-label",
              for: "cr-filter-framework"
            }, "Framework", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "cr-filter-framework",
              modelValue: _ctx.crFilters.framework,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.crFilters.framework) = $event)),
              options: _ctx.optionsForFrameworks,
              optionLabel: "label",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "All Frameworks",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[38] || (_cache[38] = _createElementVNode("label", {
              class: "filter-label",
              for: "cr-filter-tier"
            }, "Tier", -1)),
            _createVNode(_component_Select, {
              inputId: "cr-filter-tier",
              modelValue: _ctx.crFilters.tier,
              "onUpdate:modelValue": [
                _cache[13] || (_cache[13] = ($event: any) => ((_ctx.crFilters.tier) = $event)),
                _ctx.onCategoryChange
              ],
              options: _ctx.tierTypes,
              optionLabel: "value",
              optionValue: "id",
              placeholder: "Tier",
              class: "dashboard-select",
              showClear: ""
            }, null, 8, ["modelValue", "options", "onUpdate:modelValue"])
          ]),
          (_ctx.crFilters.tier == 10107)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _cache[39] || (_cache[39] = _createElementVNode("label", {
                  class: "filter-label",
                  for: "cr-filter-activity"
                }, "Activities", -1)),
                _createVNode(_component_MultiSelect, {
                  inputId: "cr-filter-activity",
                  modelValue: _ctx.crFilters.activity,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.crFilters.activity) = $event)),
                  options: _ctx.optionsActivityArray,
                  optionLabel: "label",
                  optionValue: "value",
                  filter: true,
                  maxSelectedLabels: 1,
                  selectedItemsLabel: "{0} selected",
                  placeholder: "Select Activities",
                  class: "dashboard-filter custom-multiselect userSelect"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.crFilters.tier == 10108)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[40] || (_cache[40] = _createElementVNode("label", {
                  class: "filter-label",
                  for: "cr-filter-system"
                }, "Systems", -1)),
                _createVNode(_component_MultiSelect, {
                  inputId: "cr-filter-system",
                  modelValue: _ctx.crFilters.system,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.crFilters.system) = $event)),
                  options: _ctx.optionSystemArray,
                  optionLabel: "label",
                  optionValue: "value",
                  filter: true,
                  maxSelectedLabels: 1,
                  selectedItemsLabel: "{0} selected",
                  placeholder: "Select Systems",
                  class: "dashboard-filter custom-multiselect userSelect"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.crFilters.tier == 10109)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _cache[41] || (_cache[41] = _createElementVNode("label", {
                  class: "filter-label",
                  for: "cr-filter-project"
                }, "Projects", -1)),
                _createVNode(_component_MultiSelect, {
                  inputId: "cr-filter-project",
                  modelValue: _ctx.crFilters.project,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.crFilters.project) = $event)),
                  options: _ctx.optionsProjectArray,
                  optionLabel: "label",
                  optionValue: "value",
                  filter: true,
                  maxSelectedLabels: 1,
                  selectedItemsLabel: "{0} selected",
                  placeholder: "Select Projects",
                  class: "dashboard-filter custom-multiselect userSelect"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_ComplianceReviewSection, {
            "cr-tasks": _ctx.crTasks,
            "team-tasks": _ctx.teamTasks,
            "overdue-aging": _ctx.overdueAging
          }, null, 8, ["cr-tasks", "team-tasks", "overdue-aging"])
        ]),
        _: 1
      }, 8, ["loading", "chips", "filter-count", "onOpen", "onApply", "onReset", "onCancel", "onRemove"]),
      _createVNode(_component_DashboardSection, {
        "section-id": "kpis",
        title: "KPI Results",
        loading: _ctx.kpiLoading,
        chips: _ctx.kpiChips,
        "filter-count": _ctx.kpiFilterCount,
        onOpen: _ctx.openKpiFilters,
        onApply: _ctx.applyKpiFilters,
        onReset: _ctx.resetKpiFilters,
        onCancel: _ctx.cancelKpiFilters,
        onRemove: _ctx.removeKpiFilter
      }, {
        filters: _withCtx(() => [
          _createElementVNode("div", _hoisted_26, [
            _cache[42] || (_cache[42] = _createElementVNode("label", {
              class: "filter-label",
              for: "kpi-filter-id"
            }, "KPI", -1)),
            _createVNode(_component_Select, {
              inputId: "kpi-filter-id",
              modelValue: _ctx.kpiFilters.kpiId,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.kpiFilters.kpiId) = $event)),
              options: _ctx.optionsKpiArray,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Select KPI",
              class: "dashboard-select",
              showClear: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _cache[43] || (_cache[43] = _createElementVNode("label", {
              class: "filter-label",
              for: "kpi-filter-time"
            }, "Time Period", -1)),
            _createVNode(_component_Select, {
              inputId: "kpi-filter-time",
              modelValue: _ctx.kpiFilters.timePeriod,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.kpiFilters.timePeriod) = $event)),
              options: _ctx.kpiYearSeries,
              optionLabel: "value",
              optionValue: "id",
              placeholder: "Use page time period",
              class: "dashboard-select",
              showClear: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[44] || (_cache[44] = _createElementVNode("label", {
              class: "filter-label",
              for: "kpi-filter-teams"
            }, "Teams", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "kpi-filter-teams",
              modelValue: _ctx.kpiFilters.teams,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.kpiFilters.teams) = $event)),
              options: _ctx.departmentsList,
              optionLabel: "label",
              dataKey: "value",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "All Teams",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_KpisSection, {
            "kpi-results": _ctx.kpiResults,
            "kpi-results-by-team": _ctx.kpiResultsByTeam,
            "kpi-results-by-location": _ctx.kpiResultsByLocation
          }, null, 8, ["kpi-results", "kpi-results-by-team", "kpi-results-by-location"])
        ]),
        _: 1
      }, 8, ["loading", "chips", "filter-count", "onOpen", "onApply", "onReset", "onCancel", "onRemove"]),
      _createVNode(_component_DashboardSection, {
        "section-id": "controls",
        title: "Control Health",
        loading: _ctx.controlLoading,
        chips: _ctx.controlChips,
        "filter-count": _ctx.controlFilterCount,
        onOpen: _ctx.openControlFilters,
        onApply: _ctx.applyControlFilters,
        onReset: _ctx.resetControlFilters,
        onCancel: _ctx.cancelControlFilters,
        onRemove: _ctx.removeControlFilter
      }, {
        filters: _withCtx(() => [
          _createElementVNode("div", _hoisted_29, [
            _cache[45] || (_cache[45] = _createElementVNode("label", {
              class: "filter-label",
              for: "control-filter-cid"
            }, "CID", -1)),
            _createVNode(_component_Select, {
              inputId: "control-filter-cid",
              modelValue: _ctx.controlFilters.control,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.controlFilters.control) = $event)),
              options: _ctx.controlsList,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Select CID",
              class: "dashboard-select",
              showClear: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[46] || (_cache[46] = _createElementVNode("label", {
              class: "filter-label",
              for: "control-filter-time"
            }, "Time Period", -1)),
            _createVNode(_component_Select, {
              inputId: "control-filter-time",
              modelValue: _ctx.controlFilters.timePeriod,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.controlFilters.timePeriod) = $event)),
              options: _ctx.kpiYearSeries,
              optionLabel: "value",
              optionValue: "id",
              placeholder: "Use page time period",
              class: "dashboard-select",
              showClear: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[47] || (_cache[47] = _createElementVNode("label", {
              class: "filter-label",
              for: "control-filter-teams"
            }, "Teams", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "control-filter-teams",
              modelValue: _ctx.controlFilters.teams,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.controlFilters.teams) = $event)),
              options: _ctx.departmentsList,
              optionLabel: "label",
              dataKey: "value",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "All Teams",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_ControlsSection, { "control-teams": _ctx.controlTeams }, null, 8, ["control-teams"])
        ]),
        _: 1
      }, 8, ["loading", "chips", "filter-count", "onOpen", "onApply", "onReset", "onCancel", "onRemove"]),
      _createVNode(_component_DashboardSection, {
        "section-id": "findings",
        title: "Findings & CAPAs",
        loading: _ctx.findingsLoading,
        chips: _ctx.findingsChips,
        "filter-count": _ctx.findingsFilterCount,
        onOpen: _ctx.openFindingsFilters,
        onApply: _ctx.applyFindingsFilters,
        onReset: _ctx.resetFindingsFilters,
        onCancel: _ctx.cancelFindingsFilters,
        onRemove: _ctx.removeFindingsFilter
      }, {
        filters: _withCtx(() => [
          _createElementVNode("div", _hoisted_32, [
            _cache[48] || (_cache[48] = _createElementVNode("label", {
              class: "filter-label",
              for: "findings-filter-ids"
            }, "Findings", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "findings-filter-ids",
              modelValue: _ctx.findingsFilters.findings,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.findingsFilters.findings) = $event)),
              options: _ctx.optionsForFindingIds,
              optionLabel: "label",
              dataKey: "value",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "All Findings",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[49] || (_cache[49] = _createElementVNode("label", {
              class: "filter-label",
              for: "findings-filter-capa"
            }, "CAPA Status", -1)),
            _createVNode(_component_MultiSelect, {
              inputId: "findings-filter-capa",
              modelValue: _ctx.findingsFilters.taskStatus,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.findingsFilters.taskStatus) = $event)),
              options: _ctx.statusCodes,
              optionLabel: "value",
              dataKey: "id",
              filter: true,
              maxSelectedLabels: 1,
              selectedItemsLabel: "{0} selected",
              placeholder: "CAPA Status",
              class: "dashboard-filter custom-multiselect userSelect"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_FindingsSection, {
            findings: _ctx.findingChartData,
            "team-findings": _ctx.teamFindings,
            "capa-tasks": _ctx.capaTasks,
            "capa-team-tasks": _ctx.capaTeamTasks,
            "capa-overdue-by-team": _ctx.capaOverdueByTeam
          }, null, 8, ["findings", "team-findings", "capa-tasks", "capa-team-tasks", "capa-overdue-by-team"])
        ]),
        _: 1
      }, 8, ["loading", "chips", "filter-count", "onOpen", "onApply", "onReset", "onCancel", "onRemove"])
    ])
  ]))
}